module.exports = __webpack_public_path__ + "img/secton3.0566180b.png";